export enum PocAssignee {
  TANMAY = "YXQ3J2iSlDWfuIai7pgUqtQoeHh2",
  AAMER = "dmL0pWAg2eT7Lkqd8V2QvxFSYu83",
  PRINCE = "oeok2cmtvmbBmbcHashUzwkqR4Z2",
  MONICA = "boDk56xO77aijm8ehSqKayejcCo2",
  SAGAR = "tKFCHGbakkZ3Tprgvc1gfoXmT6x2",
  CLARINA = "9XKa3tLEYbUdkn8IA7vgUwi6GJq1",
  PRIYANKA = "XY1QysjJV9fbRJXsRutF4dp0VEz2",
  SANA = "bgq15Rk0zqaaKCznER38jZwIFIE2",
  AKSHITH = "a1wssbmKEBPoiWqtUW3HsVQWCvu2",
  KHUSHBU = "XJCYY8jHFqdB09cM96bMqyVADP23",
  SADIA = "q8bDtbP8VEMsFSVEy5NKQ5KQbbu1",
  AZMATH = "1Lo76s23FPVB0QPBp4ILlSU1ScT2",
  ANKIT = "WTn9TYe4eiT6eJEH8Z0Sxok5y483",
  RACHA = "4gDs8sxgoaWKcZKilQwjivKFSPy2",
  CHINMAY = "ymx2TxND8EbQ7ay7KvyOkDehRHC3",
  SAITEJA = "7dREwmiTZ3Z5Ombg6r459q6ws8m1",
}

export const PocAssigneeLabels: Record<PocAssignee, string> = {
  [PocAssignee.TANMAY]: "Tanmay",
  [PocAssignee.AAMER]: "Aamer",
  [PocAssignee.PRINCE]: "Prince",
  [PocAssignee.MONICA]: "Monica",
  [PocAssignee.SAGAR]: "Sagar",
  [PocAssignee.CLARINA]: "Clarina",
  [PocAssignee.PRIYANKA]: "Priyanka",
  [PocAssignee.SANA]: "Sana",
  [PocAssignee.AKSHITH]: "Akshith",
  [PocAssignee.KHUSHBU]: "Khushbu",
  [PocAssignee.SADIA]: "Sadia",
  [PocAssignee.AZMATH]: "Azmath",
  [PocAssignee.ANKIT]: "Ankit",
  [PocAssignee.RACHA]: "Racha",
  [PocAssignee.CHINMAY]: "Chinmay",
  [PocAssignee.SAITEJA]: "Saiteja",
};
